// @flow
import * as React from 'react';
import {
  TextField,
  Box,
  // $FlowFixMe
} from '@mui/material';

import FieldContainer from 'Components/FieldContainer';

// $FlowFixMe
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

import { Controller } from 'react-hook-form';

import { FIBER_PROVIDERS } from 'Constants/installationAsBuild';

import RadioWithOtherField from './RadioWithOtherField';

type Props = {|
  errors: Object,
  control: Object,
  setValue: Function,
|};

function Step1(props: Props): React.Node {
  const { errors, control, setValue } = props;

  return (
    <Box>
      <FieldContainer htmlFor="siteId" label="Site ID" error={errors.siteId}>
        <Controller
          name="siteId"
          control={control}
          render={({ field }) => (
            <TextField {...field} variant="outlined" fullWidth />
          )}
        />
      </FieldContainer>

      <FieldContainer
        htmlFor="siteName"
        label="Site Name"
        error={errors.siteName}
      >
        <Controller
          name="siteName"
          control={control}
          render={({ field }) => (
            <TextField {...field} variant="outlined" fullWidth />
          )}
        />
      </FieldContainer>

      <FieldContainer
        htmlFor="siteLocation"
        label="Site Location"
        error={errors.siteLocation}
      >
        <Controller
          name="siteLocation"
          control={control}
          render={({ field }) => (
            <TextField {...field} variant="outlined" fullWidth />
          )}
        />
      </FieldContainer>

      <FieldContainer
        htmlFor="reportStartDate"
        label="Report start date"
        error={errors.reportStartDate}
      >
        <Controller
          name="reportStartDate"
          control={control}
          defaultValue=""
          render={({ field: { ref, ...rest } }) => (
            <MobileDatePicker
              id="reportStartDate-dialog"
              inputFormat="MM/DD/YYYY"
              renderInput={(params) => <TextField {...params} fullWidth />}
              {...rest}
            />
          )}
        />
      </FieldContainer>

      <FieldContainer
        htmlFor="fiberProvider"
        label="The Client (Fiber Provider)"
        error={errors.fiberProvider}
      >
        <RadioWithOtherField
          name="fiberProvider"
          control={control}
          setValue={setValue}
          options={FIBER_PROVIDERS}
          errors={errors}
          otherPlaceholder="Enter client name"
        />
      </FieldContainer>
    </Box>
  );
}

export default Step1;
